import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_journal_entry_detail,
    getReportLabel: () => t`Journal Entry Detail`,
    getColumns: () => [],
};
